export enum SelectableLocationType {
  NO_LOCATION = 0,
  ADDRESS = 1,
  PHONE = 2,
  ONLINE = 3,
  OTHER = 4,
}
